import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from 'src/app/_service/leads.service';
import { HotTableRegisterer } from '@handsontable/angular';
import { MovePartnerLeadsComponent } from '../move-partner-leads/move-partner-leads.component';
import { MatDialog } from '@angular/material/dialog';
import { LabService } from 'src/app/_service/lab.service';
declare var $: any;
@Component({
  selector: 'app-glamyo-partner-leads',
  templateUrl: './glamyo-partner-leads.component.html',
  styleUrls: ['./glamyo-partner-leads.component.css']
})
export class GlamyoPartnerLeadsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator; hideColumn: any; gender = []; sheetCircle = []; treatments = []; leadStatus = [];
  perpage: number = 25; leadsList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; submitted: boolean = false;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circle = ''; id = 'hotInstance'; search: string;
  lead_source: any; lead_sources = []; lead_status = []; leadallStatus = []; leadStatus_copy = []; circles = []; circles_copy = [];
  lead_status_search = ''; uploaded_msg: string = ''; lead_sources_copy = []; ActionOpt = [];click_to_call_loading:boolean=false;
  response_call_id='';progression_msg='';end_to_call_btn_disable=false; hotRegisterer = new HotTableRegisterer();
  @ViewChild('csvUpload', { static: false }) csvUpload: ElementRef;

  constructor(private sharedapi: SharedService, private leadapi: LeadsService, private dialog: MatDialog,private labapi: LabService,) {
    this.gender = ['Male', 'Female'];
    this.ActionOpt = ['Select', 'Move Lead'];
    this.loadCommonData();

  }

  ngOnInit(): void {
    this.getcircle();
    this.getLeadSources();
    this.getleadStatus();
  }

  ngAfterViewInit() {
    this.loadPertnerList(0, this.perpage);
  }
  async loadPertnerList(pageIndex, perpage) {
    this.leadsList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&lead_source=' + this.lead_source + '&lead_status=' + this.lead_status_search;
    this.loading = true; this.loaded = false;
    await this.leadapi.getPartnerLeadList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.leadsList = data.data;
      } else {
        this.leadsList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }
  async loadCommonData() {
    await this.leadapi.getCommonData().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.treatment;
        this.leadStatus = data.lead_status;
        this.sheetCircle = data.circle;
      } else {
        this.leadStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadPertnerList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadPertnerList(event.pageIndex, event.pageSize);
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getLeadSources() {
    this.leadapi.getLeadSources().subscribe((data: any) => {
      if (data.status) {
        this.lead_sources = data.data;
        this.lead_sources_copy = this.lead_sources;
      } else {
        this.lead_sources = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getleadStatus() {
    await this.leadapi.getLeadStatus().subscribe((data: any) => {
      if (data.status) {
        this.leadallStatus = data.data;
        this.leadStatus_copy = this.leadallStatus;
      } else {
        this.leadallStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'lead_source') {
      $("#leadsourceSearch").val('');
      $("#leadsourceSearch").focus();
      this.lead_sources = this.lead_sources_copy;
    } else if (type == 'lead_status') {
      $("#lead_status_Search").val('');
      $("#lead_status_Search").focus();
      this.leadallStatus = this.leadStatus_copy;
    }
  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } if (type == 'lead_source') {
      this.lead_sources = this.sharedapi.searchData(searchtText, this.lead_sources_copy, "source_name");
    } else if (type == 'lead_status') {
      this.leadallStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
    }

  }

  resetFilters() {
    this.search = ''; this.lead_source = ''; this.lead_status_search = ''; this.circle = '';
    this.loadPertnerList(0, 25);
  }

  //------------------------update--------------------------//

  onBeforeChange = (hotInstance, changes) => {
    let data = this.hotRegisterer.getInstance(this.id).getSourceData();
    let saveData = { id: data[hotInstance[0][0]].id, field_name: hotInstance[0][1], old_value: hotInstance[0][2], new_value: hotInstance[0][3], index: hotInstance[0][0] };

    this.saveOnChange(saveData);
  }

  async saveOnChange(saveData) {
    if (saveData.field_name == 'action') {
      if (saveData.new_value == 'Move Lead') {
        this.openMovePartnerLead(saveData);
      }
    } else {
      this.updateSingleData(saveData);
    }

  }

  openMovePartnerLead(lead_id) {
    const dialogRef = this.dialog.open(MovePartnerLeadsComponent, {
      width: '75%', height: '80%',
      data: { lead_id: lead_id }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  updateSingleData(saveData) {
    this.submitted = true;
    this.leadapi.updatePartnerLeadData(saveData).subscribe((data: any) => {
      this.submitted = false;
      if ((saveData.field_name == "description" && saveData.new_value != '') || (saveData.field_name != "description")) {
        this.sharedapi.presentToast(data.msg);
      }

    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  // -------------------------csv------------------------//
  hideModal() {
    this.uploaded_msg = '';
    $('#myModal').modal('hide');
  }

  showModal() {
    this.uploaded_msg = '';
    $('#myModal').modal();
  }

  async selectFile(event) {
    this.submitted = true;
    let file = event.target.files.item(0);
    const formData = new FormData();
    formData.append('file', file);
    this.uploaded_msg = "";
    this.leadapi.uploadLeadcsv(formData).subscribe((data: any) => {
      this.submitted = false;
      this.csvUpload.nativeElement.value = "";
      if (data.status) {
        this.uploaded_msg = data.msg;
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  afterOnCellMouseDownCallBack = (event, coords, TD) =>
    {
        if(event.target.className == 'click_to_call')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.click_to_call_function(leadId);
            console.log("leadId",leadId);
        }
    }

    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};

        this.leadapi.kaleyraClickTOCallForPartnerLeads(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            if(data.status){
                this.response_call_id = data.call_id;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.leadapi.kaleyraEndClicktoCallForPartnerLeads(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }

}
